const topics = [
  { name: '顶流恋情', heat: '985万', hot: true },
  { name: '综艺翻车', heat: '872万', hot: true },
  { name: '网红人设崩塌', heat: '756万', hot: true },
  { name: '导演黑料', heat: '689万', hot: false },
  { name: '女星小号', heat: '621万', hot: true },
  { name: '资本内幕', heat: '534万', hot: false },
  { name: '影视剧争议', heat: '478万', hot: false },
  { name: '带货翻车', heat: '412万', hot: false },
  { name: '明星投资', heat: '356万', hot: false },
  { name: '年度盘点', heat: '298万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            当前最受关注的黑料话题标签，点击查看相关爆料内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-300 ${
                topic.hot
                  ? 'bg-primary-50 text-primary-700 border border-primary-200 hover:bg-primary-100'
                  : 'bg-background-100 text-foreground-600 border border-background-200/70 hover:bg-background-200'
              }`}
            >
              <span className="text-sm font-label font-semibold whitespace-nowrap">
                {topic.hot && '🔥 '}#{topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}